import React, { useState, useEffect, useCallback } from "react";
import { Select, Row, Col, Form, Icon, Spin, DatePicker, Input, InputNumber, Button, Radio, message, Modal } from "antd";
import { BoldOutlined, PlusOutlined, ExclamationCircleOutlined, QuestionCircleOutlined, QuestionCircleFilled, InfoCircleFilled } from '@ant-design/icons';
import "./FormRegistroFormato.scss";
import { Tooltip } from "@material-ui/core";

export default function FormRegistroFormato(props) {    

    const { getFieldDecorator } = props.form;

    const [acciones, setAcciones] = useState({
        enableCaptura: props.enableCaptura != "" ? props.enableCaptura : false,
        enableModificar: false
    });

    const handleAgregar = (e) => {
        e.preventDefault();
        let valueDis = [];
        let valueReg = [];
        let valueAux;
        let value;
        console.log("Agregando a tabla:=>", props);
        props.form.validateFieldsAndScroll((err, values) => {
            console.log("Validando");
            console.log("err=>", err);
            if (!err) {
                console.log("Agregando success 1");
                //console.log('Received values of form11: ', values);
                //console.log("secciones", seccion.data,)
                //values.geografico = seccion.data[values.seccion];

                //console.log("secciones1", values.geografico,)
                valueAux = values;
                //if (values.participacion == 2) {
                valueDis.apoyo = values.apoyo;
                valueDis.discapacidad = values.discapacidad;
                valueDis.sexo = values.sexo;
                valueDis.tipoApoyo = values.tipoApoyo;
                //console.log('Received values of form11: ', values);
                if (valueAux.apoyo == 2)
                    value = 1;
                else
                    value = 0;
                valueAux.apoyo = value;
                //}
                console.log("Agregando success 2");
                props.handleAgregar(values, valueDis, valueAux);
            }
        });
    };

    const [seccion, setSeccion] = useState({
        data: props.secciones != [] ? props.secciones : [],
        loadingData: false
    });
    const [secretario, setSecretario] = useState({
        data: props.secretarios != [] ? props.secretarios : [],
        loadingData: false
    });
    const [escrutador, setEscrutador] = useState({
        data: props.escrutadores != [] ? props.escrutadores : [],
        loadingData: false
    });
    const [cSexo, setCSexo] = useState({
        data: props.cSexo != [] ? props.cSexo : [],
        loadingData: false
    });
    const [cDiscapacidad, setCDiscapacidad] = useState({
        data: props.cDiscapacidad != [] ? props.cDiscapacidad : [],
        loadingData: false
    });
    const [cApoyo, setCApoyo] = useState({
        data: props.cApoyo != [] ? props.cApoyo : [],
        loadingData: false
    });

    const [deshabilitar, setDeshabilitar] = useState(true);
    const [requerido, setRequerido] = useState(false);
    const [requeridoGeneral, setRequeridoGeneral] = useState(false);
    //console.log("response options:=>", options, seccion, secretario, escrutador, cSexo, cApoyo, cDiscapacidad);

    const handleChangeApoyo = (e) => {
        //console.log('Value changes3****');
        //console.log(e.target.value);

        if (e.target.value === 2) {
            setDeshabilitar(false)
            setRequerido(true)
        }
        else {
            setDeshabilitar(true)
            setRequerido(false)
        }
    }

    return (
      <div>
        <Form onSubmit={handleAgregar} layout="vertical" id="registroPersona">
            <>
              <Row>
                <Col span={23}>
                  <label className="texto-18-adjudicacion-b">
                    Personas con discapacidad
                  </label>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={4}>
                  <Col span={23}>
                    <label className="rojo-sesion">* </label>
                    <label className="texto-16-sesion">Sexo</label>
                  </Col>
                </Col>

                <Col span={5}>
                  <Col span={23}>
                    <label className="rojo-sesion">* </label>
                    <label className="texto-16-sesion">
                      Discapacidad{" "}
                    </label>{" "}
                    <Tooltip title="Puedes agregar más de una opción">
                      <QuestionCircleFilled className="info" />
                    </Tooltip>
                  </Col>
                </Col>
                <Col span={5}>
                  <Col span={23}>
                    <label className="rojo-sesion">* </label>
                    <label className="texto-16-sesion">
                      ¿La persona requirió apoyo para la votación?
                    </label>
                  </Col>
                </Col>
                <Col span={6}>
                  <Col span={23}>
                    <label className="rojo-sesion">* </label>
                    <label className="texto-16-sesion">
                      Tipo de apoyo para la votación{" "}
                    </label>
                    <Tooltip title="Puedes agregar más de una opción">
                      <QuestionCircleFilled className="info" />
                    </Tooltip>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col span={4}>
                  <Col span={23}>
                    <Form.Item name="sexo" hasFeedback>
                      {getFieldDecorator("sexo", {
                        rules: [
                          {
                            required: { requeridoGeneral },
                            message: "Selecciona el sexo del votante",
                          },
                        ],
                      })(
                        <Select placeholder="Selecciona">
                          {Object.entries(cSexo.data).map((value, index) => {
                            return (
                              <Select.Option key={value[0] + "-" + value[1]}>
                                {value[1]}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Col>
                <Col span={5}>
                  <Col span={22}>
                    <Form.Item name="discapacidad" hasFeedback>
                      {getFieldDecorator("discapacidad", {
                        rules: [
                          {
                            required: { requeridoGeneral },
                            message:
                              "Selecciona uno o más tipos de discapacidad.",
                          },
                        ],
                      })(
                        <Select mode="multiple" placeholder="Selecciona">
                          {Object.entries(cDiscapacidad.data).map(
                            (value, index) => {
                              return (
                                <Select.Option key={value[0] + "-" + value[1]}>
                                  {value[1]}
                                </Select.Option>
                              );
                            }
                          )}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Col>
                <Col span={5}>
                  <Col span={23}>
                    <Form.Item name="apoyo" hasFeedback>
                      {getFieldDecorator("apoyo", {
                        rules: [
                          {
                            required: { requeridoGeneral },
                            message: "Selecciona si el votante recibió apoyo.",
                          },
                        ],
                      })(
                        <Radio.Group onChange={handleChangeApoyo}>
                          <Radio value={2}> Sí </Radio>
                          <Radio value={1}> No </Radio>

                          <br />
                          <span />
                        </Radio.Group>
                      )}
                    </Form.Item>
                  </Col>
                </Col>
                <Col span={6}>
                  <Col span={23}>
                    <Form.Item name="tipoApoyo" hasFeedback>
                      {getFieldDecorator("tipoApoyo", {
                        rules: [
                          {
                            required: requerido,
                            message: "Selecciona uno o más tipos de apoyo.",
                          },
                        ],
                      })(
                        <Select
                          placeholder="Selecciona"
                          disabled={deshabilitar}
                          mode="multiple"
                        >
                          {Object.entries(cApoyo.data).map((value, index) => {
                            return (
                              <Select.Option key={value[0] + "-" + value[1]}>
                                {value[1]}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Col>
                <Col span={2} offset={2}>
                  <Col>
                    <Form.Item>
                      <Button
                        className="agregar"
                        type="primary"
                        htmlType="submit"
                        disabled={!acciones.enableCaptura}
                      >
                        <PlusOutlined />
                        Agregar
                      </Button>
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>
                    <strong><InfoCircleFilled className="info-personas"/></strong> En los campos{" "}
                    <strong>
                      <i>Discapacidad</i>
                    </strong>{" "}
                    y{" "}
                    <strong>
                      <i>Tipo de apoyo para la votación</i>
                    </strong>
                    , se puede seleccionar más de una opción
                  </span>
                  <br />
                </Col>
              </Row>
            </>
        </Form>
      </div>
    );
}